// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ja-0";